module.exports = __webpack_public_path__ + "static/media/calc-logo.08959cec.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/calc-logo.svg
// module id = 2652
// module chunks = 0